import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import VenteChargeEdit from '../vente_list/VenteChargeEdit';
import { IUserVenteListTable, ITarget } from '../../types/interfaces';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';

import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter, DateRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faFileInvoice, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { constants } from '../../types/constants';

const UserVenteTable = ({ 
  ventesData,
  setFilteredRows,
  showProjectColumn,
  showComColumn,
  allAssociationsShown
 }: IUserVenteListTable) => {
  const skipResetRef = React.useRef(false);
  const history = useHistory();
  const alert = useAlert();
  const [editChargeModal, setEditChargeModal] = useState(false);
  const [modalEditChargeVente, setModalEditChargeVente] = useState('');
  
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/consultation/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/consultation/${id}` })
    }
    else
      alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
  }

  const columns = [
      {
        Header: "ID vente",
        id: "ID vente",
        accessor: (row, index) => row.isAssLine ? row.vente?.id : row.id,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.id : undefined) : $.id`,
        Cell: ({ value }) => {
          return (<a href={value !== null && value !== undefined ? (`/consultation/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/consultation/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/consultation/${value}` })
            }
            else
              alert.error(E_ERROR.NO_CLIENT_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        }
      },
      {
        Header: "ID Bien",
        id: "ID Bien",
        accessor: (row, index) => row.isAssLine ? row.vente?.ID_BIEN : row.ID_BIEN,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.ID_BIEN : undefined) : $.ID_BIEN`,
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      ...(showProjectColumn ? [{
        Header: "Projet",
        accessor: "PROJET",
      }] : []),
      {
        Header: "Désignation",
        id: "Désignation",
        accessor: row => row.isAssLine ? `${row.vente?.DESIGNATION || ""} (${row.ETAGE === "0" ? "RDC" : `Étage ${row.ETAGE || "-"}`} ${row.POURCENTAGE}%${row.POSITION ? ` ${row.POSITION}` : ""})` : row.DESIGNATION,
        customExportDisplay: `$.isAssLine ? (($.vente && $.vente.DESIGNATION ? $.vente.DESIGNATION : "") + " (" + ($.ETAGE === "0" ? "RDC" : ("Étage " + ($.ETAGE || "-"))) + " " + $.POURCENTAGE + "%" + ($.POSITION ? (" " + $.POSITION) : "") + ")") : $.DESIGNATION`,
        // accessor: "DESIGNATION",
      },
      {
        Header: "N° Dossier",
        id: "N° Dossier",
        accessor: row => row.isAssLine ? row.vente?.NUM_DOSS : row.NUM_DOSS,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.NUM_DOSS : undefined) : $.NUM_DOSS`,
        filter: 'equals',
        // accessor: "NUM_DOSS",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Date Vente",
        id: "Date Vente",
        accessor: row => row.isAssLine ? row.createdAt : row.DATE_RESERV,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // accessor: "DATE_RESERV",
        customExportDisplay: `($.isAssLine ? $.createdAt : $.DATE_RESERV) ? new Date($.isAssLine ? $.createdAt : $.DATE_RESERV) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Type Vente",
        id: "Type Vente",
        accessor: (row, index) => row.isAssLine ? "Part d'association" : row.TYPE_VENTE === "UNIQUE" ? "Normale" : row.TYPE_VENTE === "ASSOCIATION" ? "Association" : (row.TYPE_VENTE || ""),
        customExportDisplay: `$.isAssLine ? "Part d'association" : $.TYPE_VENTE === "UNIQUE" ? "Normale" : $.TYPE_VENTE === "ASSOCIATION" ? "Association" : ($.TYPE_VENTE ? $.TYPE_VENTE : "")`,
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value, row: {original} }) => value || "-",
      },
      {
        Header: "N°",
        accessor: "N",
        filter: 'equals',
        Cell: ({ value }) => value || value === "0" ? value : "-"
      },
      // {
      //   Header: "Type",
      //   // accessor: "TYPE_2",
      //   accessor: (row, index) => row.TYPE?.toUpperCase().includes("APP") ? "Appartement" : row.TYPE?.toUpperCase().includes("MAG") ? "Magasin" : row.TYPE?.toUpperCase().includes("VILLA") ? "Villa" : "Lot",
      //   customExportDisplay: `$.TYPE || "-"`,
      //   Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
      //   filter: 'equals',
      //   Cell: ({ row }) => row.original.TYPE || "-"
      // },
      {
        Header: "Type",
        accessor: "TYPE",
        customExportDisplay: `$.TYPE || "-"`,
        filter: (rows, id, e) => rows.filter(t => (t.original[id]?.toLowerCase().includes("app") ? "Appartement" : t.original[id]?.toLowerCase().includes("mag") ? "Magasin" : (t.original[id] || "")).toLowerCase().includes(e?.toLowerCase() || "")),
        Cell: ({ row }) => row.original.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.original.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.original.TYPE || "-")
      },
      {
        Header: "Tranche",
        id: "Tranche",
        accessor: row => row.isAssLine ? row.vente?.TRANCHE : row.TRANCHE,
        customExportDisplay: `$.isAssLine ? ($.vente ? $.vente.TRANCHE : undefined) : $.TRANCHE`,
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Immeuble",
        accessor: "IMMEUBLE",
        Cell: ({ value }) => !value && value !== "0" ? "-" : value
      },
      {
        Header: "Étage",
        accessor: "ETAGE",
        // Filter: SelectColumnFilter,
        // filter: 'equals',
        Cell: ({ value }) => !value && value !== "0" ? "-" : value
      },
      {
        Header: "Pourcentage",
        accessor: "POURCENTAGE",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value, row }) => value || value === 0 ? `${value}%` : "-"
      },
      {
        Header: "Position",
        accessor: "POSITION",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Superficie",
        accessor: "SUPERFICIE",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value, row }) => row.original.TYPE_2?.toLowerCase() === "appartement" ? "-" : (value + "m²")
      },
      {
        Header: "Prix Net du M²",
        accessor: "PRIX_M",
        hidden: true,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Prix Net",
        id: "Prix Net",
        accessor: row => row.isAssLine ? row.PRIX_VENTE : row.PRIX_NET,
        customExportDisplay: `$.isAssLine ? $.PRIX_VENTE : $.PRIX_NET`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => {
          const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
          const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
          return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        },
        Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.id === "PRIX_M")?.isVisible && (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (" (" + ((row.original.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
      },
      {
        Header: "Avance",
        id: "Avance",
        accessor: row => (row.isAssLine ? row.vente?.contrat_encaissements : row.contrat_encaissements)?.filter(e => !row.isAssLine || e.ID_ASS == row.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0,
        customExportDisplay: `(($.isAssLine ? ($.vente ? $.vente.contrat_encaissements : undefined) : $.contrat_encaissements) || []).filter(e => !$.isAssLine || e.ID_ASS == $.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0`,
        // customExportDisplay: `$.isAssLine ? $.PRIX_VENTE : $.PRIX_NET`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => {
          const prixNet = row.original.isAssLine ? row.original.PRIX_VENTE : row.original.PRIX_NET;
          return value ? (<>
            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
            {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
          </>) : "-"
        }
      },
      {
        Header: "Reliquat",
        id: "Reliquat",
        accessor: row => {
          const prixNet = row.isAssLine ? row.PRIX_VENTE : row.PRIX_NET;
          return (prixNet || 0) - ((row.isAssLine ? row.vente?.contrat_encaissements : row.contrat_encaissements)?.filter(e => !row.isAssLine || e.ID_ASS == row.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)
        },
        customExportDisplay: `($.isAssLine ? ($.PRIX_VENTE || 0) : ($.PRIX_NET || 0)) - ((($.isAssLine ? ($.vente ? $.vente.contrat_encaissements : undefined) : $.contrat_encaissements) || []).filter(e => !$.isAssLine || e.ID_ASS == $.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => value ? (<>
          {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh
        </>) : "-"
      },
      ...(!allAssociationsShown ? [{
        Header: "Prix Somme Parts",
        id: "Prix Somme Parts",
        accessor: row => row.isAssLine ? 0 : row.TYPE_VENTE !== "ASSOCIATION" ? row.PRIX_NET : (row.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0),
        customExportDisplay: `$.isAssLine ? 0 : $.TYPE_VENTE !== "ASSOCIATION" ? $.PRIX_NET : ($.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") ? (<div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}</div>) : "-"
      }] : []),
      ...(!allAssociationsShown ? [{
        Header: "Avance (Parts)",
        id: "Avance (Parts)",
        accessor: row => row.isAssLine ? 0 : (row.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0),
        customExportDisplay: `$.isAssLine ? 0 : ($.contrat_encaissements ? $.contrat_encaissements.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) : 0)`,
        // customExportDisplay: `$.isAssLine ? $.PRIX_VENTE : $.PRIX_NET`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => {
          if(row.original.isAssLine)
            return "-"
          const prixNet = row.original.TYPE_VENTE !== "ASSOCIATION" ? row.original.PRIX_NET : (row.original.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0);
          return value ? (<>
            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
            {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
          </>) : "-"
        }
      }] : []),
      ...(!allAssociationsShown ? [{
        Header: "Reliquat (Parts)",
        id: "Reliquat (Parts)",
        accessor: row => {
          if(row.isAssLine)
            return 0
          const prixNet = row.TYPE_VENTE !== "ASSOCIATION" ? row.PRIX_NET : (row.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0);
          return (prixNet || 0) - (row.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)
        },
        customExportDisplay: `$.isAssLine ? 0 : (($.TYPE_VENTE !== "ASSOCIATION" ? $.PRIX_NET : ($.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)) - ($.contrat_encaissements ? $.contrat_encaissements.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) : 0))`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => value ? (<>
          {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh
        </>) : "-"
      }] : []),
      {
        Header: "Client(s)",
        id: "Client(s)",
        // accessor: "contrat_clients",
        customExportDisplay: `(($.isAssLine ? ($.vente ? $.vente.contrat_clients : undefined) : $.contrat_clients) ? ($.isAssLine ? ($.vente ? $.vente.contrat_clients : undefined) : $.contrat_clients) : []).filter(e => !$.isAssLine || e.ID_ASS == $.id).map(e => e.client).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? (e.NOM + " " + e.PRENOM) : "-").join(" / ")`,
        accessor: row => (row.isAssLine ? row.vente?.contrat_clients : row.contrat_clients)?.filter(e => !row.isAssLine || e.ID_ASS == row.id)?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
        filter: (rows, id, e) => rows.filter(t => (t.original[id] || []).filter(m => (e || "").split(" ").length === 2 ? 
          ((m.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && m.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])) || (m.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && m.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])))
          : (e || "").toLowerCase().split(" ").filter(n => m.NOM?.toString().toLowerCase().includes(n) || m.PRENOM?.toString().toLowerCase().includes(n)).length > 0).length),
        disableSortBy: true,
        Cell: ({ value }) => value?.length ? value.map(e => e ? <div className="tableCellBlocks">{`${e.NOM} ${e.PRENOM}`}</div> : null) : "-"
      },
      {
        Header: "Téléphone(s)",
        id: "Téléphone(s)",
        // accessor: "contrat_clients",
        customExportDisplay: `(($.isAssLine ? ($.vente ? $.vente.contrat_clients : undefined) : $.contrat_clients) ? ($.isAssLine ? ($.vente ? $.vente.contrat_clients : undefined) : $.contrat_clients) : []).filter(e => !$.isAssLine || e.ID_ASS == $.id).map(e => e.client).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? (e.TEL + (e.TEL2 ? (" - " + e.TEL2) : "")) : "-").join(" / ")`,
        accessor: row => (row.isAssLine ? row.vente?.contrat_clients : row.contrat_clients)?.filter(e => !row.isAssLine || e.ID_ASS == row.id)?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
        filter: (rows, id, e) => rows.filter(t => (t.original[id] || []).filter(m => m.TEL?.toString().toLowerCase().includes(e || "") || m.TEL2?.toString().toLowerCase().includes(e || "")).length),
        disableSortBy: true,
        Cell: ({ value }) => value?.length ? value.map(e => <div className="tableCellBlocks">
          {e?.TEL ? <div style={{whiteSpace: "nowrap"}}>
            {e.TEL.length >= 4 && e.TEL[0] !== "0" ? ("+" + e.TEL) : e.TEL}
            <a data-tip data-for="telI" href={`tel:${(e.TEL.length >= 4 && e.TEL[0] !== "0" ? ("+" + e.TEL) : e.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(e.TEL)} />
            <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
          {e?.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
            {e.TEL2.length >= 4 && e.TEL2[0] !== "0" ? ("+" + e.TEL2) : e.TEL2}
            <a data-tip data-for="telI2" href={`tel:${(e.TEL2.length >= 4 && e.TEL2[0] !== "0" ? ("+" + e.TEL2) : e.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(e.TEL2, 2)} />
            <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
          {!e?.TEL && !e?.TEL2 ? "-" : null}
        </div>) : "-"
      },
      {
        Header: "Statut Notaire",
        id: "Statut Notaire",
        accessor: (row, index) => (row.isAssLine ? row.vente : row)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "Signé notaire" : !!(row.isAssLine ? row.vente : row)?.en_cours_signature ? "Signature en cours" : !!(row.isAssLine ? row.vente : row)?.chez_notaire ? "Signé client" : "Pas encore signé",
        // customExportDisplay: `($.isAssLine ? ($.vente ? $.vente.bien : undefined) : $.bien) && ($.isAssLine ? $.vente : $).bien.STATUT === "${constants.STATUT_SIGNE_NOTAIRE}" ? "Signé notaire" : ($.isAssLine ? $.vente : $).en_cours_signature ? "Signé client" : "Pas encore signé"`,
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Titré",
        id: "Titré",
        accessor: (row, index) => (row.isAssLine ? row.vente?.bien : row.bien)?.disponibilite_tf === "oui" ? "Oui" : (row.isAssLine ? row.vente?.bien : row.bien)?.disponibilite_tf === "non" ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Promoteur",
        accessor: "promoteur",
        filter: (rows, id, e) => rows.filter(t => (t.original.isAssLine ? t.original.vente?.promoteurUser : t.original.promoteurUser)?.name?.toString().toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => (a.original.isAssLine ? a.original.vente?.promoteurUser : a.original.promoteurUser)?.name > (b.original.isAssLine ? b.original.vente?.promoteurUser : b.original.promoteurUser)?.name ? 1 : -1,
        customExportDisplay: `($.isAssLine ? ($.vente ? $.vente.promoteurUser : undefined) : $.promoteurUser) && ($.isAssLine ? $.vente.promoteurUser : $.promoteurUser).name ? ($.isAssLine ? $.vente.promoteurUser : $.promoteurUser).name : "-"`,
        Cell: ({ row: {original} }) => <>{(original.isAssLine ? original.vente?.promoteurUser : original.promoteurUser)?.name || "-"}</>
      },
      {
        Header: "Commercial",
        accessor: "COMMERCIAL",
        filter: (rows, id, e) => rows.filter(t => (t.original.isAssLine ? t.original.comUserAss : t.original.comUser)?.LOGIN?.toString().toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => (a.original.isAssLine ? a.original.comUserAss : a.original.comUser)?.LOGIN > (b.original.isAssLine ? b.original.comUserAss : b.original.comUser)?.LOGIN ? 1 : -1,
        customExportDisplay: `($.isAssLine ? $.comUserAss : $.comUser) && ($.isAssLine ? $.comUserAss : $.comUser).LOGIN ? ($.isAssLine ? $.comUserAss : $.comUser).LOGIN : "-"`,
        Cell: ({ row: {original} }) => (original.isAssLine ? original.comUserAss : original.comUser)?.LOGIN || "-"
      },
      {
        Header: "Chargé du bien",
        accessor: "charge_bien",
        filter: (rows, id, e) => rows.filter(t => (t.original.isAssLine ? t.original.chargeBienUserAss : t.original.chargeBienUser)?.LOGIN?.toString().toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => (a.original.isAssLine ? a.original.chargeBienUserAss : a.original.chargeBienUser)?.LOGIN > (b.original.isAssLine ? b.original.chargeBienUserAss : b.original.chargeBienUser)?.LOGIN ? 1 : -1,
        customExportDisplay: `($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser) && ($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser).LOGIN ? ($.isAssLine ? $.chargeBienUserAss : $.chargeBienUser).LOGIN : "-"`,
        Cell: ({ row: {original} }) => <>{(original.isAssLine ? original.chargeBienUserAss : original.chargeBienUser)?.LOGIN || "-"}</>
      },
      {
        Header: "Aperçus",
        className: "text-center",
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
                <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => viewCard(e, original.isAssLine ? original.vente?.id : original.id)}
                  title="Consultation">
                  <FontAwesomeIcon icon={faEye} />
                </button>
                <PDFLink documentType={"vente"}
                  func={async () => getVenteByIdPromise((original.isAssLine ? original.vente?.id : original.id) || -1)}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  // customClassNames="btn btn-info"
                  customButtonIcon={faFileInvoice}
                  allowPrintPreview={true}
                  htmlTitle="Voir la fiche de Vente"
                  customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
            </Container>
        ),
        disableSortBy: true,
      }
    ];

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [ventesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={ventesData} enableCheckBox={false} isEditable={false} setFilteredRows={setFilteredRows} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <VenteChargeEdit modal={editChargeModal} setModal={setEditChargeModal} modalVente={modalEditChargeVente} />
    </div>
  );
};

export default connect(null, {})(UserVenteTable);
